<div>
  <!-- AuditTrails -->
  <table class="table table-responsive-md text-left">
    <thead>
    <tr>
      <th>{{ 'paymentRequestInformation.auditTrail.createdAtFieldLabel' | translate }}</th>
      <th>{{ 'paymentRequestInformation.auditTrail.logMessageFieldLabel' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let auditTrail of auditTrails">
      <td>{{ auditTrail.CreatedAt | date:'d-M-y HH:mm:ss' }}</td>
      <td colspan="4">{{ auditTrail.LogMessage }}</td>
    </tr>
    </tbody>
  </table>
</div>
